/**
 * Плавающий мини-чат: кнопка на любом экране, окно поверх текущего режима.
 *
 * Соединение живёт всё время сессии, чтобы в краше можно было сразу написать
 * «нихуя себе 40x», не открывая отдельную вкладку и не теряя раунд.
 */

import { useEffect } from "react";

import { haptic } from "../lib/telegram";
import { MiniChat } from "../pages/ChatPage";
import { useChat } from "../store/chat";
import { useSession } from "../store/session";

export function ChatDock() {
  const status = useSession((state) => state.status);
  const { connect, disconnect, open, setOpen, unread, online } = useChat();

  useEffect(() => {
    if (status !== "ready") return;
    connect();
    return () => disconnect();
  }, [status, connect, disconnect]);

  if (status !== "ready") return null;

  return (
    <>
      {!open && (
        <button
          type="button"
          onClick={() => {
            haptic.tap("medium");
            setOpen(true);
          }}
          className="glow-paws fixed right-3 z-30 flex size-14 items-center justify-center rounded-full bg-night-850 text-2xl"
          style={{ bottom: "calc(5.25rem + env(safe-area-inset-bottom, 0px))" }}
          aria-label="Открыть чат"
        >
          💬
          {unread > 0 && (
            <span className="absolute -right-0.5 -top-0.5 min-w-5 rounded-full bg-paws-500 px-1 text-center text-[10px] font-extrabold text-night-950">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
          {unread === 0 && online.length > 0 && (
            <span className="absolute bottom-0.5 right-0.5 size-2.5 rounded-full border-2 border-night-850 bg-win-500" />
          )}
        </button>
      )}

      {open && (
        <div
          className="fixed inset-x-2 z-40 flex h-[min(38vh,340px)] flex-col overflow-hidden rounded-t-3xl shadow-[0_-16px_48px_rgba(0,0,0,0.55)]"
          style={{ bottom: "calc(4.75rem + env(safe-area-inset-bottom, 0px))" }}
        >
          <MiniChat onClose={() => setOpen(false)} />
        </div>
      )}
    </>
  );
}
